var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { TEAM_CACHE_LOCATION } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
import { FormRoot } from '@lucidlink/uicore/form-builder';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { TeamCacheLocation } from '../../TeamCacheLocation';
export const GlobalTeamCacheLocation = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: TEAM_CACHE_LOCATION,
    });
    const { addToast } = useToastService();
    const onSaveError = useCallback(() => {
        addToast({
            kind: 'negative',
            content: {
                message: translate("TeamCache wasn't updated"),
            },
            'data-testid': 'global-team-cache-save-error',
        });
    }, [addToast]);
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalTeamCache)({
        filespaceId,
        workspaceId,
        setting: TEAM_CACHE_LOCATION,
    }, {
        onSuccess: () => {
            handleToasts();
        },
        onError: onSaveError,
    });
    const onResetError = useCallback(() => {
        addToast({
            kind: 'negative',
            content: {
                message: translate("TeamCache wasn't reset"),
            },
            'data-testid': 'global-team-cache-reset-error',
        });
    }, [addToast]);
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: TEAM_CACHE_LOCATION,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
        onError: onResetError,
    });
    return (_jsx(FormRoot, { "data-testid": "team-cache-location", children: _jsx(TeamCacheLocation, { data: data, isSuccess: isSuccess, resetTooltip: translate('Clear TeamCache location and disable shared cache'), setSetting: setGlobalSettings, unsetSetting: unsetGlobalSetting }) }));
};
_react_refresh_temp_1 = GlobalTeamCacheLocation;
$RefreshReg$(_react_refresh_temp_1, "GlobalTeamCacheLocation");
_react_refresh_temp_2(GlobalTeamCacheLocation, "CcxzOyAR+Noad6wyLiddBNoQ86M=", false, () => [useDependency, useToastService, useDependency, useDependency]);
